import { type System, ComponentStore } from '@ecs/world';
import type { CameraResource, SpineComponent, TimeScaleResource, TransformComponent } from '@game/scenes/characterPrototype/types';

export function createSpineSyncSystem(
	spines: ComponentStore<SpineComponent>,
	transforms: ComponentStore<TransformComponent>,
	playerVisualYOffset: number
): System {
	return ({ world }) => {
		const camera = world.getResource<CameraResource>('camera');
		const timescale = world.getResource<TimeScaleResource>('timescale');
		const offsetY = camera ? camera.y : 0;
		const timeScale = timescale ? timescale.value : 1;

		spines.forEach((spineComp, entity) => {
			const transform = transforms.get(entity);
			if (!transform) return;

			spineComp.spine.position.set(transform.x, transform.y + playerVisualYOffset - offsetY);
			spineComp.controller.setTimeScale(timeScale);
		});
	};
}


